module.exports = __webpack_public_path__ + "img/Woman-1.b1562743.jpg";